export const INDICES = "INDICES";
export const INDICES_STREAM = "INDICES_STREAM";
export const INDICES_ERROR = "INDICES_ERROR";
export const INDICES_HIDE_ERROR = "INDICES_HIDE_ERROR";
export const INDICES_START_LOADER = "INDICES_START_LOADER";
export const INDICES_STOP_LOADER = "INDICES_STOP_LOADER";
